module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yOQDrJ/CoverDesign.jpg?1684514593501",
      "alt": "This image is the cover for the book Le mariage blanc du magnat grec, Dreamspun Desires (Français)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Le mariage blanc du magnat grec, Dreamspun Desires (Français)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Un mariage devient moins commode quand l’amour est impliqué.")]), _vm._v(" "), _c('p', [_vm._v("Cela commence simplement : Ondrej Kovac doit épouser Archie Katsaros pour pouvoir rester aux États-Unis, loin de sa famille médisante qui vit en Europe de l’est. En échange, Archie doit épouser Ondrej pour recevoir de l’argent pour renflouer sa société défaillante. C’est une imposture qu’aucun des deux hommes n’est convaincu de pouvoir rendre crédible.")]), _vm._v(" "), _c('p', [_vm._v("Mais alors qu’Archie introduit Ondrej dans la société new-yorkaise et que celui-ci prouve ses talents au bureau, ils commencent à découvrir une connexion entre eux. Pourront-ils surmonter la fondation instable sur laquelle leur relation a été construite, faire face à des agents inquisiteurs de l’immigration, des journalistes mondains déterminés à révéler leur supercherie et un administrateur virulent résolu à vendre la société d’Archie sous son nez ? Seulement s’ils peuvent se prouver que leur amour vaut la peine de se battre.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate McMurray, Myriam Abbas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0